import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { User } from 'api/notifications';
import { Avatar } from 'components/atoms/avatar';
import { fullName } from 'utils/full-name';
import { Strong, Value } from '../basics';

export const UserView: FC<{
  user: User;
  strong?: boolean;
  includeCompany?: boolean;
}> = ({ user, strong, includeCompany }) => (
  <>
    <Avatar
      size="small"
      name={fullName(user)}
      src={user?.photoUrl}
      alt={user?.firstName}
    />
    <FormattedMessage
      id={`notifications.messages.user_intro${
        includeCompany ? '.include_company' : ''
      }`}
      values={{
        user: strong ? (
          <Strong>{user?.firstName}</Strong>
        ) : (
          <Value>{user?.firstName}</Value>
        ),
        company: strong ? (
          <Strong>{user?.company?.companyName}</Strong>
        ) : (
          <Value>{user?.company?.companyName}</Value>
        ),
      }}
    />
  </>
);
